//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { createContext, useContext } from 'react';

import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import { RequestTextSource } from '@uia/rights/forms/RequestText';

interface UIARightsRequestContextProps {
  requestTextSource: RequestTextSource;
  setRequestTextSource: (config: RequestTextSource) => void;
  selectedRightsOption?: IRightsOption;
  setSelectedRightsOption: (option?: IRightsOption) => void;
  requestTextIndex: number;
  setRequestTextIndex: (index: number) => void;
}

export const UIARightsRequestContext =
  createContext<UIARightsRequestContextProps>({
    requestTextSource: RequestTextSource.CONFIG,
    setRequestTextSource: () => ({}),
    selectedRightsOption: undefined,
    setSelectedRightsOption: () => ({}),
    requestTextIndex: 0,
    setRequestTextIndex: () => ({}),
  });

export const UIARightsRequestContextProvider = UIARightsRequestContext.Provider;

export const useUIARightsRequestContext = () => {
  return useContext(UIARightsRequestContext);
};
